"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/BlockedTable.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _Table = require('./components/Table'); var _Table2 = _interopRequireDefault(_Table);
var _Row = require('./Row'); var _Row2 = _interopRequireDefault(_Row);















/* One page of the recipients the launch gate would refuse, ready for bulk
 * removal. Select all selects the page shown. */
const BlockedTable = ({
  orgKey,
  blocked,
  selectableKeys,
  selectedRowsMap,
  onSetRowSelection,
  onSetRowsBatchSelection,
  areAnyRowsSelected,
  onAddPatients,
  columns,
  onMoveColumn,
}) => {
  const { rows, isLoading, page, pageCount, onPage } = blocked
  const onSetAllRowsSelection = _react.useCallback.call(void 0, 
    (isSelected) => onSetRowsBatchSelection(selectableKeys, isSelected),
    [selectableKeys, onSetRowsBatchSelection],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Table2.default, {
        onSetAllRowsSelection: onSetAllRowsSelection,
        areAnyRowsSelected: areAnyRowsSelected,
        hasItems: rows.length > 0,
        isLoading: isLoading,
        onAddPatients: onAddPatients,
        columns: columns,
        onMoveColumn: onMoveColumn,
        emptyLabel: "Every unsent recipient can be sent this message."       ,
        page: page, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}

        ,  rows.map((row, i) => {
          const patientKey = _optionalChain([row, 'access', _ => _.Patient, 'optionalAccess', _2 => _2.PatientKey])
          const canSelect = !!patientKey && selectableKeys.includes(patientKey)
          return (
            _react2.default.createElement(_Row2.default, {
              key: _nullishCoalesce(patientKey, () => ( `deleted:${i}`)),
              orgKey: orgKey,
              row: row,
              isSelected: !!patientKey && !!selectedRowsMap[patientKey],
              onToggleSelection: patientKey && canSelect ? b => onSetRowSelection(patientKey, b) : null,
              columns: columns, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
            )
          )
        })
      )
      , _react2.default.createElement(_RecipientTable.RecipientPager, { page: page, pageCount: pageCount, onPage: onPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
    )
  )
}

exports. default = _react.memo.call(void 0, BlockedTable)
